import React, {useContext} from 'react';
import { Form, DatePicker } from 'antd';
import GenericDialog from '../../common/GenericDialog';
import {BrandContext} from "../../common/BrandContext";
import {WarningAmber} from "@mui/icons-material";

const ArchiveAllDialog = ({
                              open,
                              onClose,
                              archiveAllForm,
                              onArchiveAll,
                              handleSetArchiveDate,
                              user,
                              forAssessmentsShortcut = false
                          }) => {

    const brandConfig = useContext(BrandContext);

    return (
        <GenericDialog
            title={forAssessmentsShortcut ? "Archive "+brandConfig.testsName+""  :"Archive 'Test Families'"}
            open={open}
            onClose={() => {
                onClose();
                archiveAllForm.resetFields();
            }}
            buttons={[
                {
                    name: 'Cancel',
                    extraProps: { type: 'text' },
                },
                {
                    name: <div className={'flex smallGap'}><span>Archive all</span><WarningAmber sx={{fontSize:18}} /></div>,
                    callback: onArchiveAll
                },
            ]}
        >
            {!forAssessmentsShortcut && <p className="warningMessage" style={{ marginBottom: '8px' }}>
                Archiving a test family will archive its tests as well.
            </p>}
            <Form
                form={archiveAllForm}
                labelCol={{ span: 14 }}
                wrapperCol={{ span: 12 }}
            >
                <Form.Item
                    label={forAssessmentsShortcut ? "Archive "+brandConfig.testsName+" before"  :"Archive Test Families before"}
                    name="beforeDate"
                    rules={[{ required: true, message: 'Please select date.' }]}
                >
                    <DatePicker
                        style={{ marginLeft: '8px' }}
                        format={user.getDateFormatString()}
                        onChange={(date, dateString) => {
                            handleSetArchiveDate(dateString);
                        }}
                    />
                </Form.Item>
            </Form>
        </GenericDialog>
    );
};

export default ArchiveAllDialog;
